import styled from "styled-components";
import colors from "../../styles/colors";

export const ModalKitButton = styled.button`
  background: none;
  color: ${colors.product.outOfStock};
  font-weight: normal;
  font-size: unset;
  border-radius: 0;
  text-decoration: underline;

  :hover {
    text-decoration: none;
  }
`;
